import React from 'react'
import SocialGroup from '../../models/SocialModel'
import SocialCard from '../../components/SocialCard'
import { Social } from '../../components/Footer/styles'

interface Props {
	socials: SocialGroup[],
}

const SocialContainer: React.FC<Props> = ({ socials = [] }) => {
	return (
		<Social>
			{socials.map( (social,i) => (
				<SocialCard 
					social={social.social} 
					url={social.url}
					key={i} 
				/>
			))}
		</Social>
	)
}

export default SocialContainer